import { render, staticRenderFns } from "./Delegations-table.vue?vue&type=template&id=e24de654"
import script from "./Delegations-table.vue?vue&type=script&lang=js"
export * from "./Delegations-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports